import React from 'react';

import Setting from './Setting';

const SettingsWindow = props => {

    const classList = ['settings-window'];
    if (props.open) {
        classList.push('settings-window--open');
    }

    return (
        <div className={classList.join(' ')} onClick={props.closed}>
            <div className="settings">
                {props.settings.map(setting => {
                    return <Setting
                        key={setting.id}
                        title={setting.title}
                        icon={setting.icon}
                        isActive={setting.id === props.activeSetting}
                        clicked={() => props.clicked(setting.id)}
                    />
                })}
            </div>
        </div>
    );
}

export default SettingsWindow;